// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"0117df88","547":"23d1ad45","581":"fe67f889","601":"20a63714","746":"438b31cb","881":"eab96eca","962":"d9b9b08e"}[chunkId] + ".chunk.css";
};